<div
  class="flex"
  [ngClass]="{
    'flex-col gap-3': orientation() === 'vertical',
    'flex-row gap-4': orientation() === 'horizontal'
  }"
>
  @for (item of items(); track item.key) {
    <ui-radio-item
      [key]="item.key"
      [label]="item.label"
      [optionValue]="item.value"
      [(selectedValue)]="selectedValue"
      [variant]="variant()"
    />
  }
</div>
